import React, { useState, useEffect } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { NAV_LINKS, IMAGES } from "../data/content";

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => { setOpen(false); }, [location.pathname]);

  return (
    <header
      data-testid="main-navbar"
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-500 ${
        scrolled ? "glass-nav py-3" : "py-5 bg-transparent"
      }`}
    >
      <nav className="container-loft flex items-center justify-between">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-3 group">
          <img src={IMAGES.emblem} alt="London's Loft of Lyfe emblem" className="h-11 w-11 object-contain transition-transform duration-500 group-hover:scale-105" />
          <span className="leading-tight">
            <span className="block font-serif text-lg md:text-xl text-[#EFE7FA] tracking-wide">London's Loft of Lyfe</span>
            <span className="block overline text-[0.6rem] text-[#0B7A5A]">The 5L Method™</span>
          </span>
        </Link>

        <div className="hidden lg:flex items-center gap-7">
          {NAV_LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              className={({ isActive }) =>
                `text-sm tracking-wide transition-colors duration-300 hover:text-[#C4A2E8] ${
                  isActive ? "text-[#C4A2E8]" : "text-[#EFE7FA]/75"
                }`
              }
              end={l.to === "/"}
            >
              {l.label}
            </NavLink>
          ))}
        </div>

        <div className="hidden lg:block">
          <Link to="/contact" data-testid="nav-cta-button" className="btn-primary text-sm">
            Begin Your Journey
          </Link>
        </div>

        <button
          data-testid="mobile-menu-toggle"
          onClick={() => setOpen((v) => !v)}
          className="lg:hidden p-2 text-[#EFE7FA]"
          aria-label="Toggle menu"
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </nav>

      {open && (
        <div data-testid="mobile-menu" className="lg:hidden glass-nav mt-3 mx-4 rounded-2xl p-6 flex flex-col gap-1">
          {NAV_LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.to === "/"}
              className={({ isActive }) =>
                `py-3 px-2 rounded-lg text-base transition-colors ${
                  isActive ? "text-[#C4A2E8] bg-white/50" : "text-[#EFE7FA]/80"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
          <Link to="/contact" className="btn-primary mt-4 text-sm">Begin Your Journey</Link>
        </div>
      )}
    </header>
  );
}
